import {GET_ALL_DATA} from "../types";
import {GET_LANG} from "../types";
import {GET_JSON} from "../types";
import {SET_JSON} from "../types";

export const getAllData = (productsData) => {
  const action = {
    type: GET_ALL_DATA,
    productsData,
    loading: true,
  };
  console.log(action);
  return action;
};
export const getLang = (lang, dir, textAlign) => {
  const action = {
    type: GET_LANG,
    lang,
    dir,
    textAlign,
  };
  console.log(action);
  return action;
};
export const getCountryJson = (id, getJson, updatedCountry) => {
  const action = {
    type: GET_JSON,
    id,
    getJson,
    updatedCountry,
  };
  console.log(action);
  return action;
};

export const setCountryJson = (updatedJson, updatedCountry) => {
  const action = {
    type: SET_JSON,
    updatedJson,
    updatedCountry,
  };
  console.log(action);
  return action;
};
